/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hw_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why does my ideal weight look different from what I expected?`)
};

const es_hw_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué mi peso ideal se ve diferente de lo que esperaba?`)
};

const de_hw_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum sieht mein Idealgewicht anders aus als erwartet?`)
};

const nl_hw_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom ziet mijn ideaal gewicht er anders uit dan ik verwachtte?`)
};

const fr_hw_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi mon poids idéal semble-t-il différent de ce que j'attendais ?`)
};

const it_hw_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché il mio peso ideale sembra diverso da quello che mi aspettavo?`)
};

const pt_br2_hw_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que meu peso ideal parece diferente do que esperava?`)
};

const pt_hw_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que é que o meu peso ideal parece diferente do que esperava?`)
};

const ja_hw_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`理想体重が予想と異なるのはなぜですか？`)
};

const zh_hw_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么我的理想体重和我预期的不一样？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hw_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hw_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hw_faq4_q", locale)
	if (locale === "en") return en_hw_faq4_q(inputs)
	if (locale === "es") return es_hw_faq4_q(inputs)
	if (locale === "de") return de_hw_faq4_q(inputs)
	if (locale === "nl") return nl_hw_faq4_q(inputs)
	if (locale === "fr") return fr_hw_faq4_q(inputs)
	if (locale === "it") return it_hw_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_hw_faq4_q(inputs)
	if (locale === "pt") return pt_hw_faq4_q(inputs)
	if (locale === "ja") return ja_hw_faq4_q(inputs)
	return zh_hw_faq4_q(inputs)
};